export * from './set-password.component';
export * from './set-password.trans';
